import React from 'react';
import { Route, Switch } from "react-router";
import {
	ROUTE_CHANGE_PASSWORD,
	ROUTE_NEW_ACCOUNT,
	ROUTE_PAGE_INITIAL,
	ROUTE_PAGE_LOGIN,
	ROUTE_VERIFICATION
} from "./routes";
// Έχει σημασία η σειρά δήλωσης. Place unauthenticated routes here
const ROUTES = [
	ROUTE_PAGE_INITIAL,
	ROUTE_CHANGE_PASSWORD,
	ROUTE_NEW_ACCOUNT,
	ROUTE_VERIFICATION,
	ROUTE_PAGE_LOGIN,
]

const UnauthenticatedRouter = () => {
	return (
		<Switch>
			{ROUTES.map(route => {
				const { key, path, exact, component } = route;
				return (
					<Route
						key={key}
						path={path}
						exact={exact}
						component={component}
					/>
				);
			})}
			{/* You can add more routes here. Examples:
			  * <Redirect from={'/login'} to={'/'}/>
			    <Route path={'/'}>
				  <NotFound/>
			    </Route>
			  */}
		</Switch>
	);
};

export default UnauthenticatedRouter;